/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * The service of the DID document.
 */
export interface Service {
    /** The ID of the service. */
    id: string;
    /** The service endpoint of the service. */
    serviceEndpoint: string;
    /** The type of the service. */
    type: string;
}
